import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const ChatIcon = (props: IconProps) => (
  <Icon
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      id="Vector"
      d="M3.33317 3.33317H16.6665V13.3332H4.30817L3.33317 14.3082V3.33317ZM3.33317 1.6665C2.4165 1.6665 1.67484 2.4165 1.67484 3.33317L1.6665 18.3332L4.99984 14.9998H16.6665C17.5832 14.9998 18.3332 14.2498 18.3332 13.3332V3.33317C18.3332 2.4165 17.5832 1.6665 16.6665 1.6665H3.33317ZM4.99984 9.99984H11.6665V11.6665H4.99984V9.99984ZM4.99984 7.49984H14.9998V9.1665H4.99984V7.49984ZM4.99984 4.99984H14.9998V6.6665H4.99984V4.99984Z"
    />
  </Icon>
);

export default memo(ChatIcon);
